/* eslint-disable no-unused-vars */
import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { queryClient } from '@hc/utils';
import { httpRequest } from '@hc/utils/axios';
import { toast } from 'react-hot-toast';
import create from 'zustand';

export const useMasterWhen = create((set, get) => ({
  masterWhenData: [],
  loading: null,
  error: null,
  getMasterWhenData: async () => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query

      const { data, status } = await queryClient.fetchQuery({
        queryKey: ['masterWhen'],
        queryFn: async () => {
          const { data } = await httpRequest(
            'get',
            `${envConfig.api_url}/master/get-when`,
            {},
            true
          );
          return data;
        },
        staleTime: Infinity,
      });

      const masterWhenDataCopy = [];

      if (Array.isArray(data) && data?.length > 0) {
        data.map((val) => {
          masterWhenDataCopy.push({
            value: val?.id ?? '',
            name: val?.when ?? '',
            label: val?.when ?? '',
          });
        });
      }
      return set((state) => ({
        loading: false,
        masterWhenData: masterWhenDataCopy,
      }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
}));
